"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEmptyStocks = exports.REMOVE_EMPTY_STOCKS = void 0;
exports.REMOVE_EMPTY_STOCKS = '/v2/stocks/empty';
const removeEmptyStocks = (client) => async (sellerId) => {
    await client.delete(exports.REMOVE_EMPTY_STOCKS + `?sellerId=${sellerId}`);
    return;
};
exports.removeEmptyStocks = removeEmptyStocks;
